import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  modal: {
    minHeight: 136,
    padding: '32px 0 32px 0'
  },
  basic: {
    minHeight: 122
  },
  title: {
    marginLeft: 16
  },
  titleContainer: {
    marginTop: 32,
    marginLeft: 32,
    width: 'calc(100% - 32px)'
  },
  emptyContent: {
    marginTop: 20,
    width: 'calc(100% - 64px)'
  },
  row: {
    marginTop: 18,
    '& > :not(:first-child)': {
      marginLeft: 8
    },
    '& > :first-child': {
      whiteSpace: 'pre'
    }
  }
})
